import './index.scss';

import _ from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useMarkDelete } from '@/src/components/project/Library/api/markDelete';
import { usePermanentDelete } from '@/src/components/project/Library/api/permanentDelete';
import { showToast } from '@/src/globalFunction';
import { RootState } from '@/src/reducers/types';

const modalId = 'deleteFile';

const DeleteFile = ({ itemIdsVersioned, onClose, isMultipleDelete = false }) => {
  const dispatch = useDispatch();
  const files = useSelector((state: RootState) => state.files);

  useEffect(() => {
    $(`#${modalId}`).on('hidden.bs.modal', () => {
      dispatch({ type: 'FILES_TOGGLE_DELETE_MODAL_DISPLAY' });
    });
  }, [dispatch]);

  const inTrash = files.activeInSidebar.id === 'trash';
  // const folderId = files.selected.id;
  const markDeleteMutation = useMarkDelete();
  const permanentDeleteMutation = usePermanentDelete();

  const handleDelete = async () => {
    const response = await markDeleteMutation.mutateAsync({
      itemIdsVersioned,
      inTrash: !inTrash,
    });

    if (response['error-results'].length > 0) {
      showToast('error', 'Something went wrong. Please try again later.');
      return;
    }

    if (response['conflict-results'].length > 0) {
      showToast('error', 'The document has already been upated. Please refresh and try again.');
      return;
    }

    dispatch({ type: 'RESET_SELECTED_ITEMS' });

    const deletedFiles = response['success-results'];
    const typeLabel = deletedFiles.some((f) => f.source === 'document' || f.type === 'document')
      ? 'file/s '
      : 'folder/s ';

    showToast('success', `${deletedFiles.length} ${typeLabel} has been deleted`);

    onClose();
  };

  const handlePermanentlyDelete = async () => {
    await permanentDeleteMutation.mutateAsync({
      folderIds: itemIdsVersioned.map((f) => f.id),
    });

    showToast('success', `${itemIdsVersioned.length} has been deleted`);

    dispatch({ type: 'RESET_SELECTED_ITEMS' });

    onClose();
  };

  return (
    <div className={`modal fade show in delete-file-modal bg-overlay`} id={modalId}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bb pd20 pdl40 pdr40">
            <div className="row">
              <div className="col-lg-10 col-md-10 col-sm-10">
                <p className="text-size18 brndnTxt-m m0">
                  Delete {isMultipleDelete ? files.selectedItems.length : 'this'} files/folders
                </p>
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <a data-dismiss="modal" onClick={onClose}>
                  <i className="material-icons text-size22">close</i>
                </a>
              </div>
            </div>
          </div>
          <div className="modal-body">
            {!inTrash ? (
              <p>You are about to delete selected files/folders. Do you wish to proceed?</p>
            ) : (
              <p>{`${
                isMultipleDelete ? 'These' : 'This'
              } files/folders will be permanently deleted. Do you wish to proceed?`}</p>
            )}
          </div>
          <div className="modal-footer bt">
            <div className="footerActions">
              <div className="actionButton">
                <button
                  type="button"
                  className="btn btnCancel"
                  data-dismiss="modal"
                  onClick={onClose}
                >
                  Cancel
                </button>
              </div>
              <div className="actionButton others">
                <button
                  type="button"
                  className="btnDelete active"
                  onClick={inTrash ? handlePermanentlyDelete : handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteFile;
